<template>
  <div class="m-input-box">
    <div class="mImport" @click="show=true">
      <span class="label" v-if="label">{{label}}</span>
      <p class="m-rads" v-if="value">{{ showName }}</p>
      <p class="m-rads notHaveVal" v-if="!value">{{ placeholder }}</p>
      <span class="icon icon-arrow-right unit"></span>
    </div>
    <van-actionsheet v-model="show" :actions="dataList" cancel-text="取消" @select="onSelect"/>
    <span class="error" :class="{ hasLabel:label }" v-if="errors()"><span class="icon icon-note"></span>{{validationErrors}}</span>
  </div>
</template>

<script>
import { Actionsheet } from 'vant'
import Vue from 'vue'

Vue.use(Actionsheet)
export default {
  props: {
    value: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '请输入'
    },
    label: {
      type: String,
      default: ''
    },
    dataList: {
      type: Array,
      default: []
    }
  },
  computed: {
    showName () {
      var str = ''
      for (var key in this.dataList) {
        if (this.dataList[key].id === this.value) {
          str = this.dataList[key].name
        }
      }
      return str
    }

  },
  data () {
    return {
      show: false,
      submitOld: this.$validation,
      inputModel: this.value,
      validationErrors: null,
      modelExpression: this.$options._parentVnode.data.model.expression
    }
  },
  inject: ['$validation'],
  watch: {
    //      'inputModel' (newV,oldV){//        this.$validation.validate
    //        this.$nextTick(()=>{
    //          this.validationErrors = this.$validation.validAll(this.modelExpression)
    //        })
    //      },
    //      'submitOld.submit' (newV,oldV) {
    //        if(newV){
    //          this.validationErrors=this.$validation.validAll(this.modelExpression)
    //        }
    //      }
  },
  mounted () {
    this.$root.$on('showErr', (obj) => {
      this.errors()
    })
  },
  methods: {
    onSelect (item) {
      this.show = false
      this.inputModel = item.id
      this.$emit('input', item.id)
    },
    errors () {
      this.validationErrors = this.$validation.error(this.modelExpression)
      return this.validationErrors
    }
  }
}
</script>
<style ref="stylesheet/scss" lang="scss" scoped>
  @import "@/assets/style/variables.scss";

  .m-input-box {
    background: $light;
    padding: 0 15px !important;
    color: $dark;
    font-size: 16px;
    border-bottom: 1px solid #f5f5f5;
  }

  .label {
    flex: 0 0 80px;
    font-size: 17px;
  }

  .hasLabel {
    padding-left: 80px;
  }

  .mImport {
    align-items: center;
    height: 50px;
    display: flex;

  }

  p {
    border: none;
    width: 100%;
  }

  .error {
    color: #f25930;
    display: inline-block;
    padding-bottom: 10px;
  }

  .unit {
    flex: 0 0 auto;
  }

  .notHaveVal {
    color: #757575;
  }
</style>
